import React, { Component } from 'react';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Confirm from 'react-confirm-bootstrap';
import { Admin as Layout } from '../../../components/layouts';
import { Spinner } from '../../../components/common';
import { AdminApi } from '../../../api';
import FormModal from '../../../components/admin/common/Form';
import ShowModal from '../../../components/admin/common/Show';
import TemplatesModal from '../../../components/admin/publisher/templates/TemplatesModal';
import ExportCSVButton from '../../../components/common/ExportCSVButton';
import { ButtonShow, ButtonEdit, ButtonDelete, ButtonWebsiteTemplate } from '../../../components/common/buttons/actions';
import { ButtonAdd } from '../../../components/common/buttons';
import { generateFilter, handleOnFilterChange, handleOnSortChange, handleOnPageChange } from '../../../utils/helpers/admin/query_updating';
import { columnWidth, formatData } from '../../../utils/helpers/admin/table_formatters';
import { humanize } from '../../../utils/helpers/text_formatters';

class AdminWebsiteIndex extends Component {
  componentWillMount() {
    this.fetchResource();
  }

  fetchResource(params = {}) {
    const { dispatch } = this.props;

    dispatch(AdminApi.actions.website(params));
    dispatch(AdminApi.actions.websiteTemplate());
  }

  handleNew() {
    const {
      resourceName,
      dispatch,
      resource: {
        meta: { column_info },
      },
    } = this.props;

    dispatch(
      show('AdminResourceModal', {
        attributes: column_info.attributes,
        formFields: column_info.new_form,
        resourceName,
        heading: 'New Website',
        formAction: 'Create',
        metaParams: {},
      }),
    );
  }

  handleShow(_uuid, website) {
    const { resourceName, dispatch } = this.props;

    dispatch(
      show('AdminResourceShow', {
        resource: website,
        resourceName,
        heading: 'Website Details',
        onEdit: this.handleEdit.bind(this),
        onDelete: this.handleDelete.bind(this),
        showButtons: true,
      }),
    );
  }

  handleDelete(uuid, callback = null) {
    const { resourceName, dispatch } = this.props;

    dispatch(
      AdminApi.actions[`${resourceName}Delete`].post(uuid, (_error, success) => {
        if (success) {
          this.fetchResource({
            page: this.props?.resource?.meta?.pagination?.page || 1,
            per_page: this.props?.resource?.meta?.pagination?.per_page || 10,
            filters: this.props?.resource?.meta?.filters || {},
            sort: this.props?.resource?.meta?.sort || {},
          });
          if (callback) callback();
        }
      }),
    );
  }

  handleEdit(_uuid, website) {
    const {
      resourceName,
      dispatch,
      resource: {
        meta: { column_info },
      },
    } = this.props;
    const metaParams = {
      page: this.props?.resource?.meta?.pagination?.page || 1,
      per_page: this.props?.resource?.meta?.pagination?.per_page || 10,
      filters: this.props?.resource?.meta?.filters || {},
      sort: this.props?.resource?.meta?.sort || {},
    };

    dispatch(
      show('AdminResourceModal', {
        attributes: column_info.attributes,
        formFields: column_info.edit_form,
        resourceName,
        resource: website,
        heading: `Editing ${humanize(resourceName)}`,
        formAction: 'Update',
        metaParams,
        onShow: this.handleShow.bind(this),
      }),
    );
  }

  handleEditWebsiteTemplate(_uuid, website) {
    const {
      dispatch,
      websiteTemplate: {
        data: { data: websiteTemplates },
      },
    } = this.props;
    const templates = websiteTemplates.filter(t => t.publisher_website_id === website.id).sort(t => t.default_source);
    const template = templates.find(t => t.default === true) || templates[0] || null;

    dispatch(
      show('adminWebsiteTemplateModal', {
        website,
        templates,
        template,
      }),
    );
  }

  renderActions(c, r) {
    return (
      <ul className="list-inline">
        <li>
          <ButtonShow className="btn-trans" bsStyle="primary" onClick={this.handleShow.bind(this, c, r)} />
        </li>
        <li>
          <ButtonEdit className="btn-trans" bsStyle="primary" onClick={this.handleEdit.bind(this, c, r)} />
        </li>
        {(r.deleted_at === undefined || r.deleted_at === null) && (
          <li>
            <Confirm
              onConfirm={this.handleDelete.bind(this, c)}
              body="Are you sure you want to delete this?"
              confirmText="Confirm Delete"
              title={`Deleting Website ${r.name} (ID#${r.id})`}
            >
              <div>
                <ButtonDelete className="btn-trans" bsStyle="primary" />
              </div>
            </Confirm>
          </li>
        )}
        <li>
          <ButtonWebsiteTemplate className="btn-trans" bsStyle="primary" onClick={this.handleEditWebsiteTemplate.bind(this, c, r)} />
        </li>
      </ul>
    );
  }

  render() {
    const { resourceName, resource, isLoading, fetchParams, columnAttributes } = this.props;
    const { data, meta } = resource || {};
    const { filters } = meta || {};
    const { pagination, column_info, sort } = meta || {};
    const index = column_info?.index_page || [];

    if (index.length > 1) index.move(index.indexOf('uuid'), 0);

    const CSVButton = () => {
      return <ExportCSVButton resourceName={resourceName} filters={filters} sort={sort} visible />;
    };

    const options = {
      exportCSVBtn: CSVButton,
      onFilterChange: handleOnFilterChange.bind(this, fetchParams, this.fetchResource.bind(this)),
      onSortChange: handleOnSortChange.bind(this, fetchParams, this.fetchResource.bind(this)),
      sortName: sort?.field || 'id',
      sortOrder: sort?.order || 'desc',
      defaultSortName: sort?.field || 'id',
      defaultSortOrder: sort?.order || 'desc',
      sizePerPage: pagination?.per_page || 10,
      onPageChange: handleOnPageChange.bind(this, fetchParams, this.fetchResource.bind(this)),
      sizePerPageList: [10, 20, 50, 100],
      pageStartIndex: 1,
      page: pagination?.current_page || 1,
    };
    const fetchInfo = {
      dataTotalSize: pagination?.total_count || 0,
    };
    const selectRow = {
      mode: 'checkbox',
    };
    const passProps = pick(this.props, ['routeParams', 'location', 'routes']);

    return (
      <Layout {...passProps}>
        <div className="ibox">
          <div className="ibox-title">
            <h5>{humanize(resourceName)}</h5>
          </div>
          <div className={`ibox-content${isLoading ? ' sk-loading' : ''}`}>
            <Spinner />
            <div className="m-b-sm text-right pull-right">
              <ButtonAdd onClick={this.handleNew.bind(this)} className="m-l-xs" bsStyle="info" btnLabel={`Add ${humanize(resourceName)}`} />
            </div>
            <BootstrapTable
              exportCSV
              striped
              ref={`${resourceName}Table`}
              data={data || []}
              remote
              pagination
              fetchInfo={fetchInfo}
              selectRow={selectRow}
              options={options}
            >
              {index.length > 1 ? (
                index.map((field, i) => {
                  const isResourceKey = field === 'uuid';

                  return (
                    <TableHeaderColumn
                      key={`${resourceName}-column-${i}`}
                      isKey={isResourceKey}
                      width={columnWidth(field, columnAttributes)}
                      dataSort={!isResourceKey}
                      dataField={field}
                      filter={isResourceKey ? {} : generateFilter(resourceName, field, meta)}
                      dataFormat={isResourceKey ? this.renderActions.bind(this) : formatData.bind(this, field, columnAttributes)}
                      tdStyle={{ whiteSpace: 'normal' }}
                      thStyle={{ whiteSpace: 'normal' }}
                    >
                      {isResourceKey ? 'Actions' : field}
                    </TableHeaderColumn>
                  );
                })
              ) : (
                <TableHeaderColumn isKey dataField={resourceName} />
              )}
            </BootstrapTable>
            <FormModal />
            <ShowModal />
            <TemplatesModal />
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const resourceName = 'website';
  const resource = state.admin[resourceName];
  const websiteTemplate = state.admin.websiteTemplate;
  const columnAttributes = resource?.data?.meta?.column_info?.attributes || {};
  const fetchParams = {
    page: resource?.data?.meta?.pagination?.page || 1,
    per_page: resource?.data?.meta?.pagination?.per_page || 10,
    filters: resource?.data?.meta?.filters || {},
    sort: resource?.data?.meta?.sort || {},
  };

  return {
    resourceName,
    resource: resource.data,
    isLoading: resource.loading,
    fetchParams,
    websiteTemplate,
    columnAttributes,
  };
};

export default connect(mapStateToProps)(AdminWebsiteIndex);
